var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('navBar'),_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/image/icon.png")}}),_vm._v(" Dashboard ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }